export const drawerWidth = 240;

export const dataframePageSizeOptions = [10, 100];

export const codingPickedFroms = [
  { value: "daily-challenge", display: "Daily challenge" },
  { value: "hard", display: "Hard" },

];